const i18n = {
  'en-US': {
    'banner.slogan1': 'Start with production demand entry',
    'banner.subSlogan1': 'Enter your production demand',
    'banner.slogan2': 'AI agent assists in production plan completion',
    'banner.subSlogan2': 'Agent is always there, ready to help you',
    'banner.slogan3': 'Multiple professional AI agents',
    'banner.subSlogan3': 'AI agents help you query various information, assist you in handling daily tasks, and improve your efficiency'
  },
  'zh-CN': {
    'banner.slogan1': '从录入生产需求开始',
    'banner.subSlogan1': '录入您的销售订单，或者计划生产需求',
    'banner.slogan2': '智能体全程协助生产计划的完成',
    'banner.subSlogan2': '智能体时刻在，及时响应您的需求，为您提供专业的服务',
    'banner.slogan3': '多种专业的智能体助手',
    'banner.subSlogan3': '智能体帮您查询各种信息，协助您处理日常事务，提升工作效率'
  }
};
export default i18n;